interface SwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeStyles = {
  sm: {
    container: 'h-5 w-9',
    thumb: 'h-3 w-3',
    translate: {
      on: 'translate-x-5',
      off: 'translate-x-1'
    }
  },
  md: {
    container: 'h-6 w-11',
    thumb: 'h-4 w-4',
    translate: {
      on: 'translate-x-6',
      off: 'translate-x-1'
    }
  },
  lg: {
    container: 'h-7 w-14',
    thumb: 'h-5 w-5',
    translate: {
      on: 'translate-x-8',
      off: 'translate-x-1'
    }
  }
};

export function Switch({
  checked,
  onCheckedChange,
  disabled = false,
  id,
  size = 'md'
}: SwitchProps) {
  const styles = sizeStyles[size];

  return (
    <button
      type="button"
      id={id}
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      className={`
        relative inline-flex items-center rounded-full
        transition-colors duration-200 ease-in-out
        focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2
        ${styles.container}
        ${checked ? 'bg-indigo-600' : 'bg-gray-200 dark:bg-gray-600'}
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
      `}
    >
      <span
        className={`
          inline-block transform rounded-full bg-white
          transition-transform duration-200 ease-in-out
          ${styles.thumb}
          ${checked ? styles.translate.on : styles.translate.off}
        `}
      />
    </button>
  );
}
